import { Routes, Route } from 'react-router-dom';
import { OrganizationsLandingGate } from './OrganizationsLandingGate';
import { OrganizationsConsole } from './OrganizationsConsole';

/**
 * Organizations module top-level router.
 *
 *   /services/organizations          → landing gate: redirect to console if
 *                                      already activated, else activation hero
 *   /services/organizations/*        → the console (overview, contacts, …)
 */
export function OrganizationsPage() {
  return (
    <Routes>
      <Route index element={<OrganizationsLandingGate />} />
      <Route path="*" element={<OrganizationsConsole />} />
    </Routes>
  );
}

export default OrganizationsPage;
